<template>
  <div class="page page-with-bg page-cancelable">
    <div class="page-form-wrap">
      <div class="page-form-cancel">
        <b-btn class="page-cancel-button"
               variant="link"
               type="submit"
               to="/reports">
          <svg-icon name="close" /> Cancel
        </b-btn>
      </div>
      <div class="page-form-header small-header">
        <h1>Data for Lab Req</h1>
      </div>
      <div class="mb-3">
        We need a few extra data points to get the labs ordered.
      </div>
      <div>
        Note: Address and phone number are optional but help reduce <br />
        confusion at the lab. Your patient will be able to edit these when they <br />
        take their Preassessment Questionnaire.
      </div>
      <div class="page-form-content">
        <b-form @submit.prevent="submit">
          <validation-summary :errors="errors"></validation-summary>
          <v-form-group :validator="$v.report.survey.birthDate"
                        label="Patient Date of Birth">
            <date-picker :key="report.survey.birthDate"
                         v-model="report.survey.birthDate"
                         slot-scope="{ attrs, listeners }"
                         placeholder="Patient Date of Birth"
                         v-bind="attrs"
                         v-on="listeners" />
          </v-form-group>
          <v-form-group :validator="$v.report.survey.gender">
            <b-form-radio-group class="gender-radio" v-model="report.survey.gender">
              <b-form-radio name="gender-male" :value="Gender.Male">Male</b-form-radio>
              <b-form-radio name="gender-female" :value="Gender.Female">Female</b-form-radio>
            </b-form-radio-group>
          </v-form-group>
          <v-form-group label="Patient Address 1 (optional)">
            <b-form-input slot-scope="{ attrs, listeners }"
                          v-bind="attrs"
                          v-on="listeners"
                          v-model="report.survey.address.address1"
                          placeholder="Patient Address 1 (optional)" />
          </v-form-group>
          <v-form-group label="Patient Address 2 (optional)">
            <b-form-input slot-scope="{ attrs, listeners }"
                          v-bind="attrs"
                          v-on="listeners"
                          v-model="report.survey.address.address2"
                          placeholder="Patient Address 2 (optional)" />
          </v-form-group>
          <v-form-group label="Patient ZIP (optional)">
            <b-form-input slot-scope="{ attrs, listeners }"
                          v-bind="attrs"
                          v-on="listeners"
                          v-model="report.survey.address.zip"
                          placeholder="Patient ZIP (optional)" />
          </v-form-group>
          <v-form-group label="Patient Phone Number (optional)">
            <form-input-formatted type="phone"
                                  id="phone"
                                  v-model="report.survey.phoneNumber"
                                  placeholder="Patient Phone Number (optional)" />
          </v-form-group>
          <b-form-group class="form-buttons">
            <b-btn variant="success" type="submit">Submit</b-btn>
          </b-form-group>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  const { mapState, mapActions } = createNamespacedHelpers('report');

  import { required } from "vuelidate/lib/validators";
  import { isAdult } from "utils/custom-validators";

  import formMixin from "mixins/form-mixin";

  import Gender from "enums/gender";
  import ReportStatus from "enums/report-status";

  export default {
    mixins: [formMixin],

    validations: {
      report: {
        survey: {
          birthDate: { required, isAdult },
          gender: { required }
        }
      }
    },

    data() {
      return {
        Gender
      }
    },

    computed: {
      ...mapState(["report"]),
    },

    methods: {
      ...mapActions(["createReport"]),

      async onSubmit() {
        this.report.status = ReportStatus.OrderLabsFirst;
        await this.createReport();
        this.$root.successToast("Report created!");
        this.$router.push("../create/completed");
      }
    }
  }
</script>

<style lang="scss" scoped>
  .gender-radio {
    display: flex;
    justify-content: space-between;
    margin: 0 10%;
  }
</style>